import config from '../config.json'

export const ubyHubMixin = {
  computed: {
    customElementRegistry() {
      return window.customElements
    },
  },
  methods: {
    /**
     * compute based on DOM fetching the current hub sidebar width if any
     */
    // TODO not reactive, to call on-demand when sidebar is loaded so that at least it is computed properly once
    getHubSidebarWidth() {
      if (
        this.$refs.sidebarWidget !== undefined &&
        this.$refs.sidebarWidget?.shadowRoot !== undefined
      ) {
        // HACK: computed prop does not update when sidebarWidget innerHTML changes, so we force return a fixed width for now ... TOFIX
        return '30px' // Si pas de Uby-Hub, on ne veut pas prendre de la place inutile

        // // On regarde dans le DOM si le burger menu Uby-Hub est actif
        // const isExtended =
        //   this.$refs.sidebarWidget.shadowRoot.innerHTML.includes(
        //     'class="active"'
        //   )
        // if (isExtended) return '260px' // Si c'est le cas alors il fait 260px
        // else return '40px' // Sinon il en fait 40
      }

      return '0px' // Si pas de Uby-Hub, on ne veut pas prendre de la place inutile
    },
    async initHub() {
      // if hub widget URL is available
      if (config.ubyHub[this.$backendName].widgetURL) {
        let widgetSrc
        try {
          const rawResponse = await fetch(
            config.ubyHub[this.$backendName].widgetURL,
          )

          widgetSrc = await rawResponse.text()
        } catch (fetchWidgetError) {
          this.$log.error(
            `[ubyHubMixin.initHub][error] unable to fetch widget src from remote: '${fetchWidgetError}'.`,
          )
          this.$log.error(fetchWidgetError)
          //TODO show toaster error to end user ?
        }

        if (widgetSrc) {
          try {
            // declare func that will enable access to html tag '<sidebar-widget>' in template
            // eslint-disable-next-line no-new-func
            const widgetFunction = await new Function(widgetSrc)
            // init widget in DOM
            widgetFunction()

            // return pointer to created element
            // TODO: we should init shadow element with attachShadow() ou customElementRegistry.define() to return created element
            return this.$refs.sidebarWidget
          } catch (callWidgetCtorError) {
            this.$log.error(
              `[ubyHubMixin.initHub][error] unable to call widget constructor: '${callWidgetCtorError}'.`,
            )
            this.$log.error(callWidgetCtorError)
          }
        }

        // fallback
        return null
      }
    },
  },
}
